import { render, staticRenderFns } from "./portability.vue?vue&type=template&id=54a70a18&"
import script from "./portability.vue?vue&type=script&lang=js&"
export * from "./portability.vue?vue&type=script&lang=js&"
import style0 from "./portability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports